import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { forwardRef, memo } from "react";
import classes from "./style.module.scss";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalCustom = forwardRef(function ModalCustom(
  {
    open,
    onClose,
    title = "",
    children,
    footerEnd,
    className = "",
    fullWidth = true,
    maxWidth = "lg",
    openAlign = "center",
    responsive = true,
    blur = false,
    ...rest
  },
  ref
) {
  const getAlign = () => {
    switch (openAlign) {
      case "top":
        return "flex-start";
      case "bottom":
        return "flex-end";
      default:
        return "center";
    }
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      fullScreen={responsive ? fullScreen : false}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      TransitionComponent={Transition}
      onClose={onClose}
      ref={ref}
      className={`${className} ${blur && classes.modalBlur}`}
      {...rest}
      sx={{
        "& .MuiDialog-container": {
          alignItems: getAlign(),
        },
      }}
    >
      <DialogTitle className={classes.modalTitle}>{title}</DialogTitle>
      <IconButton aria-label="بستن" onClick={onClose} className={classes.closeButton}>
        <CloseIcon />
      </IconButton>
      <DialogContent>{children}</DialogContent>
      {footerEnd && <Divider />}
      <DialogActions className={classes.modalFooter}>{footerEnd}</DialogActions>
    </Dialog>
  );
});

export const Modal = memo(ModalCustom);
